"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _common = require("../../common");

var _lib = require("../../lib");

var _Item = _interopRequireDefault(require("./Item"));

require("./styles.css");

var _customClassNames = require("../../common/customClassNames");

var _constants = require("../../constants");

var _ = require("..");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj["default"] = obj;
    return newObj;
  }
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var DropdownOptions =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(DropdownOptions, _PureComponent);

  _createClass(DropdownOptions, null, [{
    key: "mapOption",
    value: function mapOption(option, key) {
      if ((0, _lib.isObj)(option)) {
        var title = option.title,
            label = option.label,
            text = option.text,
            name = option.name;
        return Object.assign({}, option, {
          key: key,
          title: title || label || text || name // set all possible Text to title property

        });
      }

      return {
        key: key,
        title: option,
        value: option
      };
    }
  }]);

  function DropdownOptions(props) {
    var _this;

    _classCallCheck(this, DropdownOptions);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(DropdownOptions).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "setDirection", function (direction) {
      _this.setState({
        direction: direction
      });
    });

    _defineProperty(_assertThisInitialized(_this), "getDirection", function () {
      var direction = _this.props.direction;
      var parent = _this.props.parent;
      var listNode = _this.innerRef.current;

      if (!parent && _this.innerRef && listNode) {
        parent = listNode.parentNode;
      }

      var parentPos = parent.getBoundingClientRect();
      var _document$documentEle = document.documentElement,
          scrollTop = _document$documentEle.scrollTop,
          scrollLeft = _document$documentEle.scrollLeft; // default direction

      var horizontalDir = null;
      var verticalDir = 'auto'; // string direction props

      if ((0, _lib.isStringMatch)(direction, [].concat(_toConsumableArray(_constants.DIRECTION_VERTICAL), ['auto']))) {
        verticalDir = direction;
      }

      if ((0, _lib.isStringMatch)(direction, _constants.DIRECTION_HORIZONTAL)) {
        horizontalDir = direction;
      } // array direction props


      if ((0, _lib.arrayHasItems)(direction)) {
        var hasVertical = false;
        var hasHorizontal = false;
        direction.forEach(function (v) {
          if (!hasVertical && (0, _lib.isStringMatch)(v, [].concat(_toConsumableArray(_constants.DIRECTION_VERTICAL), ['autoV']))) {
            verticalDir = v;
            hasVertical = true;
          }

          if (!hasHorizontal && (0, _lib.isStringMatch)(v, [].concat(_toConsumableArray(_constants.DIRECTION_HORIZONTAL), ['autoH']))) {
            horizontalDir = v;
            hasHorizontal = true;
          }
        });
      }

      switch (horizontalDir) {
        case 'autoH':
          if (listNode && parentPos.left + scrollLeft + listNode.clientWidth > _this.maxWidth) {
            horizontalDir = 'left';
          } else {
            horizontalDir = 'right';
          }

          break;

        case horizontalDir:
          break;

        default:
          horizontalDir = null;
          break;
      }

      switch (verticalDir) {
        case 'auto':
        case 'autoV':
          if (listNode && parentPos.bottom + scrollTop + listNode.clientHeight > _this.maxHeight) {
            verticalDir = 'top';
          } else {
            verticalDir = 'bottom';
          }

          break;

        case verticalDir:
          break;

        default:
          verticalDir = 'bottom';
          break;
      }

      return [horizontalDir, verticalDir];
    });

    _defineProperty(_assertThisInitialized(_this), "setPosition", function (dir) {
      var parent = _this.props.parent;
      var listNode = _this.innerRef.current;

      if (!parent && _this.innerRef && listNode) {
        parent = listNode.parentNode;
      }

      var parentPos = parent.getBoundingClientRect();
      var _document$documentEle2 = document.documentElement,
          scrollLeft = _document$documentEle2.scrollLeft,
          scrollTop = _document$documentEle2.scrollTop;
      var styles = [];
      var horizontalDir = dir[0];
      var verticalDir = dir[1];

      switch (verticalDir) {
        case 'top':
          if (!horizontalDir) {
            styles.push("top: ".concat(parentPos.top + scrollTop - listNode.clientHeight, "px;"));
          } else {
            styles.push("top: ".concat(parentPos.bottom + scrollTop - listNode.clientHeight, "px;"));
          }

          break;

        default:
          if (!horizontalDir) {
            styles.push("top: ".concat(parentPos.bottom + scrollTop, "px;"));
          } else {
            styles.push("top: ".concat(parentPos.bottom + scrollTop - parentPos.height, "px;"));
          }

          break;
      }

      switch (horizontalDir) {
        case 'left':
          styles.push("left: ".concat(parentPos.left + scrollLeft - listNode.clientWidth, "px;"), "width: ".concat(listNode.clientWidth, "px;"));
          break;

        case 'right':
          styles.push("left: ".concat(parentPos.left + scrollLeft + parentPos.width, "px;"), "width: ".concat(listNode.clientWidth, "px;"));
          break;

        default:
          styles.push("left: ".concat(parentPos.left + scrollLeft, "px;"), "width: ".concat(parentPos.width, "px;"));
          break;
      }

      listNode.setAttribute('style', styles.join('\n'));
    });

    _defineProperty(_assertThisInitialized(_this), "maxHeight", null);

    _defineProperty(_assertThisInitialized(_this), "maxWidth", null);

    _defineProperty(_assertThisInitialized(_this), "innerRef", _react["default"].createRef());

    _defineProperty(_assertThisInitialized(_this), "classNames", function () {
      var withPortal = _this.props.withPortal;
      var propNames = ['disabled', 'scrollable', 'withPortal'];
      var names = [DropdownOptions.className];
      (0, _lib.addClassByPropName)(names, _this.props, propNames);

      if (!withPortal) {
        (0, _customClassNames.addDirection)(names, _this.state.direction);
      }

      (0, _customClassNames.addAttachedVertical)(names, _this.props.attached);
      return names.join(' ');
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnChange", function (e, data) {
      (0, _lib.callEventMethods)(e, 'persist', 'preventDefault', 'stopPropagation');
      var _this$props = _this.props,
          onChange = _this$props.onChange,
          disabled = _this$props.disabled;

      if (disabled) {
        return;
      }

      if (onChange) {
        onChange(e, data);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "renderOptions", function () {
      var _this$props2 = _this.props,
          loading = _this$props2.loading,
          loaderNode = _this$props2.loaderNode,
          isItemSelected = _this$props2.isItemSelected,
          itemNode = _this$props2.itemNode,
          emptyNode = _this$props2.emptyNode,
          disabled = _this$props2.disabled,
          textAlign = _this$props2.textAlign;

      if (loading && loaderNode) {
        return loaderNode;
      }

      var options = _this.state.options;

      if ((0, _lib.arrayHasItems)(options)) {
        return options.map(function (item, idx) {
          var itemProps = {
            onChange: _this.handleOnChange,
            textAlign: textAlign,
            disabled: item.disabled || disabled,
            selected: isItemSelected ? isItemSelected(item.value) : false
          };
          return itemNode(item, idx, itemProps);
        });
      }

      if (emptyNode) {
        return emptyNode;
      }

      return null;
    });

    _defineProperty(_assertThisInitialized(_this), "renderContent", function () {
      var _this$props3 = _this.props,
          as = _this$props3.as,
          className = _this$props3.className,
          children = _this$props3.children,
          options = _this$props3.options,
          innerRef = _this$props3.innerRef,
          withPortal = _this$props3.withPortal,
          loading = _this$props3.loading,
          loaderNode = _this$props3.loaderNode,
          isItemSelected = _this$props3.isItemSelected,
          onChange = _this$props3.onChange,
          textAlign = _this$props3.textAlign,
          visible = _this$props3.visible,
          scrollable = _this$props3.scrollable,
          attached = _this$props3.attached,
          itemNode = _this$props3.itemNode,
          emptyNode = _this$props3.emptyNode,
          direction = _this$props3.direction,
          parent = _this$props3.parent,
          rest = _objectWithoutProperties(_this$props3, ["as", "className", "children", "options", "innerRef", "withPortal", "loading", "loaderNode", "isItemSelected", "onChange", "textAlign", "visible", "scrollable", "attached", "itemNode", "emptyNode", "direction", "parent"]);

      var Wrapper = (0, _lib.getElementType)(_assertThisInitialized(_this), _this.props);

      var classNames = _this.classNames();

      return _react["default"].createElement(Wrapper, _extends({}, rest, {
        className: classNames,
        ref: function ref(_ref) {
          return (0, _lib.combineRefs)(_ref, innerRef, _this.innerRef);
        }
      }), _this.renderOptions());
    });

    var _options = props.options;
    var newOptions = DropdownOptions.getOptions(props);
    _this.state = {
      prevProps: {
        options: _options
      },
      options: newOptions,
      direction: null
    };
    return _this;
  }

  _createClass(DropdownOptions, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props4 = this.props,
          visible = _this$props4.visible,
          withPortal = _this$props4.withPortal;
      var direction = this.state.direction;
      var dir = this.getDirection();

      if (visible && prevProps.visible !== visible) {
        if (!direction || direction[0] !== dir[0] || direction[1] !== dir[1]) {
          this.setDirection(dir);
        }

        if (withPortal && this.innerRef.current) {
          this.setPosition(dir);
        }
      }

      if (!visible && prevProps.visible !== visible) {
        this.maxHeight = null;
        this.maxWidth = null;
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props5 = this.props,
          visible = _this$props5.visible,
          withPortal = _this$props5.withPortal;
      this.maxHeight = (0, _lib.getDocumentHeight)();
      this.maxWidth = (0, _lib.getDocumentWidth)();

      if (!visible) {
        return null;
      }

      if (withPortal) {
        return _react["default"].createElement(_.Portal, {
          node: document.body
        }, this.renderContent());
      }

      return this.renderContent();
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      var prevProps = state.prevProps; // Compare the incoming prop to previous prop

      var options = props.options;
      var newOptions = DropdownOptions.getOptions(props);
      return {
        // Store the previous props in state
        prevProps: {
          options: options
        },
        options: prevProps.options !== options ? newOptions : state.options
      };
    }
  }, {
    key: "getOptions",
    value: function getOptions(props) {
      var options = props.options;
      var children = props.children;

      if (children) {
        options = _react.Children.toArray(children).filter(function (child) {
          return DropdownOptions.isDropdownItem(child);
        }).map(function (child) {
          return child.props;
        });
      }

      return [].concat(options).map(DropdownOptions.mapOption);
    }
  }]);

  return DropdownOptions;
}(_react.PureComponent);

exports["default"] = DropdownOptions;

_defineProperty(DropdownOptions, "Item", _Item["default"]);

_defineProperty(DropdownOptions, "isDropdownItem", function (child) {
  return (0, _lib.isFunc)(child.type) && child.type.name === _Item["default"].name;
});

_defineProperty(DropdownOptions, "className", 'MHub-Dropdown-List');

_defineProperty(DropdownOptions, "displayName", 'DropdownOptions');

_defineProperty(DropdownOptions, "propTypes", {
  as: _common.customPropTypes.as,
  className: _propTypes["default"].string,
  visible: _propTypes["default"].bool,
  loading: _propTypes["default"].bool,
  loaderNode: _propTypes["default"].node,
  options: _common.customPropTypes.dropdownOption,
  children: _propTypes["default"].node,
  disabled: _propTypes["default"].bool,
  onChange: _propTypes["default"].func,
  isItemSelected: _propTypes["default"].func,
  scrollable: _propTypes["default"].bool,
  attached: _propTypes["default"].oneOfType([_propTypes["default"].bool, _common.customPropTypes.attachedVertical]),
  itemNode: _propTypes["default"].func,
  emptyNode: _propTypes["default"].node,
  innerRef: _common.customPropTypes.ref,
  textAlign: _common.customPropTypes.textAlign,
  withPortal: _propTypes["default"].bool,
  direction: _propTypes["default"].oneOfType([_propTypes["default"].oneOf([].concat(_toConsumableArray(_constants.DIRECTION_ALL), ['auto'])), _propTypes["default"].arrayOf(_propTypes["default"].oneOf([].concat(_toConsumableArray(_constants.DIRECTION_ALL), ['autoV', 'autoH'])))]),
  parent: _common.customPropTypes.ref
});

_defineProperty(DropdownOptions, "defaultProps", {
  as: 'ul',
  className: null,
  visible: false,
  loading: false,
  loaderNode: _react["default"].createElement("p", null, "Loading ..."),
  options: [],
  children: null,
  disabled: false,
  onChange: null,
  isItemSelected: null,
  scrollable: true,
  attached: 'top',
  itemNode: function itemNode(item, idx, props) {
    return _react["default"].createElement(_Item["default"], _extends({}, item, props, {
      key: item.value || idx
    }));
  },
  emptyNode: _react["default"].createElement(_Item["default"], null, "No result found."),
  innerRef: null,
  textAlign: null,
  withPortal: false,
  direction: 'auto',
  parent: null
});